import { normalizeSelectValue } from '../../model/normalize-select-value';
import { useAppStore } from 'features/settings/contexts/settings.context';
import { FC, useMemo } from 'react';
import { Select } from 'shared';

type Props = {
  placeholder?: string;
  branch?: number;
  onChange: (branch?: number) => void;
  isClearable: boolean;
};

export const SelectBranch: FC<Props> = ({ branch, onChange, placeholder, isClearable }) => {
  const {
    state: { branches }
  } = useAppStore();

  const options = useMemo(() => branches.map((b) => ({ value: b.value.toString(), label: b.label })), [branches]);
  const currentOption = useMemo(() => options.find((b) => b.value === branch?.toString()) ?? null, [options, branch]);

  return (
    <Select
      isMulti={false}
      options={options}
      value={currentOption ? [currentOption] : []}
      onChange={(val) => onChange(normalizeSelectValue(val, false)?.[0])}
      placeholder={placeholder ?? ''}
      isClearable={isClearable}
      instanceId={`Branch-select`}
      highlightSelected
      isSolid
    />
  );
};
